
import CustomButton from '../CustomButton/CustomButton';
const MeetTeam = () => {
    return (
        <section className="py-3">
            <div className="container text-center">
                <div className="row g-4 mb-5">
                    {teamMembers.map((member, index) => (
                        <div className="col-6 col-lg-2 col-md-3" key={index}>
                            <div className="team-member text-center">
                                <img src={member.image} alt={member.name} className="img-fluid mb-4 rounded mx-auto d-block" />
                                <p className="mt-1 font-bold text-black">{member.name}</p>
                                <p className="mb-3">{member.position}</p>
                                <p className="small mb-3">{member.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row justify-content-center">
                    <div className="col-auto">
                        <CustomButton
                            label="Careers"
                            variant="red"
                            size="small"
                            href="/careers"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
const teamMembers = [
    {
        name: "Knox Graham, CFO",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/KnoxGraham.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-facebook-f", link: "#" }
        ]
    },
    {
        name: "Grace Musgrove, EVP Brand Strategy",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/GraceMusgrove.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-github", link: "#" },
            { icon: "fab fa-twitter", link: "#" }
        ]
    },
    {
        name: "James Marshall, EVP Market Research",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/JamesMarshall.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-dribbble", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Sanya Deshmukh, EVP Trademarks",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/SanyaDeshmukh.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Ivy Leiter, VP Computational Linguistics",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/IvyLeiter.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Stephen Hill, VP Brand Architecture",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/StephenHill.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Dean Dunleavy, VP IT",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/DeanDunleavy.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Malik Ells, VP Visual Identity",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/MalikElls.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Robert Perez, VP Global Naming",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/RobertPerez.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Andee Banks, INN/USAN Liaison & Submissions",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/AndeeBanks.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Solene Raveneaux, Naming Strategist",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/SoleneRaveneaux.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
    {
        name: "Antonio Reyes - Specialist, Drug Naming and Risk",
        position: "",
        description: "",
        image: `${awsImageBaseUrl}images/PeoplePurposet/headshots/AntonioReyes.png`,
        socials: [
            { icon: "fab fa-linkedin-in", link: "#" },
            { icon: "fab fa-twitter", link: "#" },
            { icon: "fab fa-instagram", link: "#" }
        ]
    },
];

export default MeetTeam;